export default __webpack_public_path__ + "static/media/teletrax.284ec4ad.png";